import { HeaderPrimary } from "@components/site/HeaderPrimary"
import { Icon } from "@components/ui/Icon"
import { formatVenueShortAddress } from "@utils/venues"
import { defineBlock } from "eddev/blocks"
import { Link } from "eddev/routing"
import { cloneElement, ReactElement, ReactNode, useEffect, useMemo } from "react"
import { proxy } from "valtio"

export const meta: BlockMeta = {
  title: "Venue Header",
  inserter: false,
  postMetaBlock: {
    postTypes: ["venue"],
    fieldName: "venueInfo",
  },
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("venue/venue-header", (props) => {
  useEffect(() => {
    Object.assign(venueHeader, props)
  }, [props])

  let rows = useMemo(() => {
    const info = props!
    const nodes: ReactElement[] = []
    if (info.address?.streetAddress) {
      nodes.push(
        <Link
          href={googleMapsUrl(info.address.streetAddress)}
          target="_blank"
          onClick={(e) => {
            e.preventDefault()
            openMap(info.address?.streetAddress!)
          }}
        >
          {formatVenueShortAddress(info.address)}
        </Link>,
      )
    }
    if (info.phoneNumber) {
      nodes.push(<Link href={`tel:${info.phoneNumber}`}>{info.phoneNumber}</Link>)
    }
    if (info.websiteUrl) {
      nodes.push(
        <Link href={info.websiteUrl} target="_blank">
          {info.websiteUrl.replace(/https?:\/\/(www\.)?/, "").replace(/\/.*$/, "")}
        </Link>,
      )
    }
    return nodes
  }, [])

  return (
    <div className="mb-4">
      <HeaderPrimary title={props.venue?.title!} featuredText="" featuredImage={props?.image!} theme="pink">
        <ul className="border-t-[0.1em] border-black flex flex-col gap-3 pt-3">
          {rows.map((row, i) => (
            <li key={i} className="block relative group">
              {cloneElement(row, {
                className: "flex pr-6 !w-full !flex justify-between items-center hover-link",
              })}
              <span className="absolute right-0 top-0 bottom-0 flex items-center pointer-events-none">
                <Icon name="chevronRight" className="w-4 h-4" />
              </span>
            </li>
          ))}
        </ul>
      </HeaderPrimary>
    </div>
  )
})

export function googleMapsUrl(streetAddress: string) {
  const address = encodeURIComponent(streetAddress)
  return `https://www.google.com/maps/search/?api=1&query=${address}`
}

function openMap(streetAddress: string) {
  const encoded = encodeURIComponent(streetAddress)
  // @ts-ignore
  const ua = navigator.userAgent || navigator.vendor || window.opera
  let url = ""
  // @ts-ignore
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    // iOS: Use Apple Maps protocol
    url = `maps://?q=${encoded}`
  } else if (/Android/.test(ua)) {
    // Android: Use geo URI
    url = `geo:0,0?q=${encoded}`
  } else {
    // Fallback: Google Maps
    url = googleMapsUrl(streetAddress)
  }
  window.open(url, "_blank")
}

export const venueHeader = proxy<Partial<BlockProps["venue/venue-header"]>>({})
